module.exports = __webpack_public_path__ + "img/folder-plus.549a9565.svg";